export var ButtonStyle = /*#__PURE__*/function (ButtonStyle) {
  ButtonStyle["DEFAULT"] = "default";
  ButtonStyle["ALTERNATIVE_1"] = "alternative_1";
  return ButtonStyle;
}({});
export var CornerStyle = /*#__PURE__*/function (CornerStyle) {
  CornerStyle["ROUNDED"] = "rounded";
  CornerStyle["SQUARED"] = "squared";
  return CornerStyle;
}({});
export var Height = /*#__PURE__*/function (Height) {
  Height["MEDIUM"] = "medium";
  Height["SMALL"] = "small";
  Height["LARGE"] = "large";
  return Height;
}({});

// TODO: Centralize all Alignment enums across extensions to use this enum
export var Alignment = /*#__PURE__*/function (Alignment) {
  Alignment["LEFT"] = "left";
  Alignment["RIGHT"] = "right";
  Alignment["CENTER"] = "center";
  return Alignment;
}({});

// TODO: Centralize all Orientation enums across extensions to use this enum
export var Orientation = /*#__PURE__*/function (Orientation) {
  Orientation["ROW"] = "row";
  Orientation["STACKED"] = "stacked";
  return Orientation;
}({});
export var CommonLayout = /*#__PURE__*/function (CommonLayout) {
  CommonLayout["FRAME_ABOVE_IMAGE"] = "frame-above-image";
  CommonLayout["SPLIT_IMAGE_RIGHT"] = "split-image-right";
  CommonLayout["SPLIT_IMAGE_LEFT"] = "split-image-left";
  CommonLayout["FULL_IMAGE_BACKGROUND"] = "full-image-background";
  CommonLayout["NO_IMAGE_BACKGROUND"] = "no-image-background";
  return CommonLayout;
}({});
export var FeedbackType = /*#__PURE__*/function (FeedbackType) {
  FeedbackType["CARDS"] = "Cards";
  FeedbackType["CAROUSEL"] = "Carousel";
  FeedbackType["COMPANY_HUB"] = "Company hub";
  FeedbackType["CUSTOMIZE_NAVIGATION"] = "Customize Navigation";
  FeedbackType["LINKS_MENU"] = "Links menu";
  FeedbackType["SPOTLIGHT"] = "Spotlight";
  FeedbackType["SECTION"] = "Section";
  FeedbackType["CUSTOM_SEARCH"] = "Custom search";
  return FeedbackType;
}({});
export var ExtensionMode = /*#__PURE__*/function (ExtensionMode) {
  ExtensionMode["RENDERER"] = "renderer";
  ExtensionMode["EDITOR"] = "editor";
  return ExtensionMode;
}({});
export var LOG_OUT = 'epic.logout.LOG_OUT';
export var RenderVariant = /*#__PURE__*/function (RenderVariant) {
  RenderVariant["MANUAL"] = "manual";
  RenderVariant["DYNAMIC"] = "dynamic";
  return RenderVariant;
}({});
export var SegmentationTargets = /*#__PURE__*/function (SegmentationTargets) {
  SegmentationTargets["ALL"] = "all";
  SegmentationTargets["EACH"] = "each";
  return SegmentationTargets;
}({});
export var ITEM_FIELDS = /*#__PURE__*/function (ITEM_FIELDS) {
  ITEM_FIELDS["CARD_ID"] = "cardId";
  ITEM_FIELDS["TITLE"] = "title";
  ITEM_FIELDS["IS_TITLE_USER_EDITED"] = "isTitleUserEdited";
  ITEM_FIELDS["DESCRIPTION"] = "description";
  ITEM_FIELDS["IS_DESCRIPTION_USER_EDITED"] = "isDescriptionUserEdited";
  ITEM_FIELDS["IS_DESCRIPTION_SHOWN"] = "isDescriptionShown";
  ITEM_FIELDS["LABEL"] = "label";
  ITEM_FIELDS["IS_LABEL_HIDDEN"] = "isLabelHidden";
  ITEM_FIELDS["LINK"] = "link";
  ITEM_FIELDS["IS_LINK_USER_EDITED"] = "isLinkUserEdited";
  ITEM_FIELDS["IMAGE_SRC"] = "imageSrc";
  ITEM_FIELDS["CONFLUENCE_PAGE_ID"] = "confluencePageId";
  ITEM_FIELDS["IMAGE_ALT_TEXT"] = "imageAltText";
  ITEM_FIELDS["SEGMENTATION_TARGETS"] = "segmentationTarget";
  ITEM_FIELDS["AUDIENCE_SEGMENTATION_GROUP_IDS"] = "audienceSegmentationGroupIds";
  // group preferences stored via this field when segmentationTarget is EACH
  ITEM_FIELDS["LINK_RESOURCE_TYPE"] = "linkResourceType";
  ITEM_FIELDS["BACKGROUND_COLOR"] = "backgroundColor";
  ITEM_FIELDS["TEXT_COLOR"] = "textColor";
  ITEM_FIELDS["LABEL_COLOR"] = "labelColor";
  ITEM_FIELDS["LAYOUT"] = "layout";
  ITEM_FIELDS["IS_BUTTON_SHOWN"] = "isButtonShown";
  ITEM_FIELDS["BUTTON_TEXT"] = "buttonText";
  ITEM_FIELDS["BUTTON_STYLE"] = "buttonStyle";
  ITEM_FIELDS["HEIGHT"] = "height";
  return ITEM_FIELDS;
}({});